import { app } from '../../../../../app';
import { Controller } from './import-shared-password.controller';

app.component('companySharingCenterSharedPasswordsImport', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./import-shared-password.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/import/import-shared-password.component.js